import { FC } from 'react';
import { Button, ButtonContentWithLoader } from '@edikk-edikk/country-layout-black';
import { useMenuContext, useMenuState } from '#baseMenu/hooks';
import { ButtonOpenSvgIcon, useMenuButtonVariant } from '#baseMenu/components';

const ButtonOpen: FC = () => {
  const { open, isOpen } = useMenuContext();
  const { isActionsBlocked, isContentLoadInProcess } = useMenuState();
  const buttonVariant = useMenuButtonVariant();

  if (isOpen) {
    return null;
  }

  return (
    <Button
      variant={buttonVariant}
      circle
      onClick={open}
      additionalClassName="flex-shrink-0"
      aria-label="Open menu"
      pointerEventsNone={isActionsBlocked}
    >
      <ButtonContentWithLoader isLoading={isContentLoadInProcess} content={<ButtonOpenSvgIcon />} />
    </Button>
  );
};

export { ButtonOpen };
